








































import DateInput from "../../core/Forms/DateInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import { Employe } from "../../models/Employe";
import Absence = Employe.Absence;
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";

export default {
    name: "AbsenceModalEdit",
    components: { CheckboxInput, EmployeSelect, TextareaInput, DateInput },
    props: {
        absence: Absence,
        forceConge: Boolean,
    },
    data() {
        return {};
    },
};
